// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__Z4Or0","tab":"Tabs_tab__3NZ06","tabActive":"Tabs_tabActive__1aCIU"};